import { apiClient } from "./client";

export async function listFormTypes() {
  const res = await apiClient.get("/v1/inspection-form-types", { params: { active: true } });
  return res.data?.data || [];
}

export async function getFormType(uid) {
  const res = await apiClient.get(`/v1/inspection-form-types/${uid}`);
  return res.data;
}
